import React, { FunctionComponent } from 'react'
import { Route, Switch } from 'react-router'
import { ROUTES } from '../http/routes'
import ProtectedRoute from './etc/ProtectedRoute'

import Page from './pages/Page/Page'
import Toaster from './controls/Toaster/Toaster'
import { loginRule } from '../constants/route-rules'
import Helmet from 'react-helmet'
import InfoPage from './pages/info/InfoPage'

const LoginPage = React.lazy(() => import('./pages/login/LoginPage/LoginPage'))

const Main: FunctionComponent = () => {
    return <React.Suspense fallback={<div/>}>
        <Helmet>
            <title>Дизайн проекты</title>
        </Helmet>
        <Switch>
            <Route path={ROUTES.LOGIN} component={LoginPage}/>
            <Route path={ROUTES.INFO} component={InfoPage}/>
            <ProtectedRoute
                path={ROUTES.ROOT}
                component={Page}
                rules={[loginRule]}
            />
        </Switch>
        <Toaster/>
    </React.Suspense>
}

export default Main